var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useCallback } from "react";
import { Icon } from "../../../components/icon/icon";
import Flex from "../../../components/templates/flex";
import StyledTab from "./styledTab";
var Tab = function (_a) {
    var active = _a.active, onActivate = _a.onActivate, tabIndex = _a.tabIndex, mouseOver = _a.onMouseOver, mouseOut = _a.onMouseOut, onClose = _a.onClose, fixed = _a.fixed, collapsed = _a.collapsed, icon = _a.icon, children = _a.children, draggableRef = _a.draggableRef, dragHandleProps = _a.dragHandleProps, tabRef = _a.tabRef, rest = __rest(_a, ["active", "onActivate", "tabIndex", "onMouseOver", "onMouseOut", "onClose", "fixed", "collapsed", "icon", "children", "draggableRef", "dragHandleProps", "tabRef"]);
    var _b = useState(), hover = _b[0], setHover = _b[1];
    var onClickTab = useCallback(function (event) {
        if (event)
            event.preventDefault();
        if (onActivate)
            onActivate();
    }, [onActivate]);
    var onMouseOver = useCallback(function (event) {
        setHover(true);
        if (mouseOver)
            mouseOver(event);
    }, [mouseOver]);
    var onMouseOut = useCallback(function (event) {
        setHover(false);
        if (mouseOut)
            mouseOut(event);
    }, [mouseOut]);
    var onCloseTab = useCallback(function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (onClose)
            onClose(tabIndex, active);
    }, [onClose, tabIndex, active]);
    var onRef = useCallback(function (node) {
        if (draggableRef)
            draggableRef(node);
        if (tabRef)
            tabRef(node);
    }, [draggableRef, tabRef]);
    var renderIcon = useCallback(function (iconProp) { return React.cloneElement(iconProp, { color: active ? "text" : "border" }); }, [active]);
    var closable = hover && !fixed;
    return (React.createElement(StyledTab, __assign({ ref: onRef, active: active, onClick: onClickTab, onMouseOver: onMouseOver, onMouseLeave: onMouseOut }, rest),
        React.createElement(Flex, null,
            closable && (React.createElement(Icon, { name: "x", size: "small", color: active ? "text" : "border", onClick: onCloseTab })),
            !closable && icon && renderIcon(icon)),
        !collapsed && React.createElement(Flex, __assign({}, dragHandleProps), children)));
};
Tab.displayName = "Tab";
export default Tab;
